// extracted by mini-css-extract-plugin
module.exports = {"cards":"cards_cards__2FhA-"};